import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import {Breadcrumb, Table, Flex} from "antd";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {useUrlSearchParams} from "use-url-search-params";
import {useList} from "modules/mandatoryRequirement/hooks";
import Pagination from "containers/Pagination";
import FilterList from "./components/FilterList";
import Button from "components/Button";
import * as Icons from "assets/icons";
import {useNavigate} from "react-router";
import config from "../../config";
import ExcelDownload from "./components/ExcelDownload";
import {useQueryClient} from "react-query";
import {ENTITY} from "modules/mandatoryRequirement/constants";

// import QuickViewModal from "./components/QuickViewModal";


const ServiceRegister = () => {
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const [params, setParams] = useUrlSearchParams();
    const queryClient = useQueryClient();
    // const [page, setPage] = useState(0);
    const [search, setSearch] = useState(0);
    // const [isModal, setModal] = useState({})

    const defaultParams = {
        search,
        page: params.page,
        filter: [
            {
                key: "organization_id",
                operation: "=",
                value: params.organization_id,
                type: "STRING",
            },
            {
                key: "function_name.sphere.id",
                operation: "=",
                value: params.sphere_id,
                type: "NUMBER",
            },
            {
                key: `service_name`,
                operation: "%_%",
                value: params.service_name,
                type: "JSON",
            },
            {
                key: "service_form",
                operation: "=",
                value: params.service_form,
                type: "STRING",
            },
            {
                key: "subject_type",
                operation: "=",
                value: params.subject_type,
                type: "STRING",
            },
            {
                key: "payment_type",
                operation: "=",
                value: params.payment_type,
                type: "STRING",
            },
        ],
    }
    const {items, meta, isFetched} = useList({
        params: defaultParams
    });

    function handleRowClick(record) {
        localStorage.clear();
        localStorage.setItem(record.id, JSON.stringify(record));
        queryClient.setQueryData([ENTITY, String(record.id)], record);
        navigate(`/mandatory-requirement/view/${record.id}`);
    }

    return (
        <>
            <Container>
                <Spacer size={35}/>

                <Breadcrumb separator=">">
                    <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
                    <Breadcrumb.Item>{t("mandatory-requirements")}</Breadcrumb.Item>
                </Breadcrumb>

                <Spacer size={32}/>

                <Title align="left" text={t("mandatory-requirements")}/>
                <Spacer size={40}/>


                {/*<FilterList {...{ params, setParams, setSearch }} />*/}
                {/*<ExcelDownload defaultParams={defaultParams} />*/}


                <Spacer size={20}/>
                <Table
                    rowKey="id"
                    // defaultSort="-id"
                    columns={[
                        {
                            title: "ID",
                            dataIndex: "id"
                        },
                        {
                            key: "info1",
                            title: "Majburiy talabning mazmuni",
                            dataIndex: "info1",
                            width: "25%"
                        },
                        {
                            key: "info2",
                            title: "Majburiy talab belgilangan normativ-huquqiy hujjat (texnik jixatdan tartibga solish sohasidagi normativ hujjat) nomi, rekvizitlari, tarkibiy birligi va unga xavola",
                            dataIndex: "info2",
                            width: "40%"
                        },
                        {
                            key: "info4",
                            title: "Majburiy talabning amal qilish muddati",
                            dataIndex: "info4",
                        },
                        {
                            key: "actions",
                            width: 50,
                            render: (_, record) => (
                                <Button
                                    background="secondary"
                                    color="secondary"
                                    border="none"
                                    radius="xs"
                                    iconOnly
                                    onClick={() => handleRowClick(record)}
                                >
                                    <Icons.ArrowRight/>
                                </Button>
                            ),
                        },
                    ]}
                    dataSource={items}
                    pagination={false}
                    loading={!isFetched}
                    onRow={record => {
                        return {
                            onClick: event => {
                                if (event.target.localName === "td")
                                    handleRowClick(record);
                            },
                        };
                    }}
                    scroll={{x: 1400}}
                />

                <Spacer size={32}/>

                <Pagination
                    current={meta.current}
                    total={meta.totalPages}
                    currentItems={items.length}
                    totalItems={meta.totalItems}
                    onChange={(page) => setParams({page})}
                />

                <Spacer size={140}/>
            </Container>
            {/*<QuickViewModal item={isModal} onCancel={() => setModal({})} />*/}
        </>
    );
};

export default ServiceRegister;
